import { render } from "./scheduled-visits.vue?vue&type=template&id=7f90e739&ts=true"
import script from "./scheduled-visits.vue?vue&type=script&lang=ts"
export * from "./scheduled-visits.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__